
const Button = (props) => {
    return (
        <button {...props} >
            {
                props.icon && !props.loading && <i className={props.icon} style={props.label ? { marginRight: 6 } : undefined} />
            }
        {props.label??""}
        
        {
           props.loading &&
           <>&nbsp;<i class="fa fa-spinner fa-spin" ></i></>
        }
      </button>
    )
} 

export {Button}